// Recovered compiled webpack factory 48302. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "InvariantError", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
  class r extends Error {
    constructor(e, t) {
      (super("Invariant: " + (e.endsWith(".") ? e : e + ".") + " This is a bug in Next.js.", t),
        (this.name = "InvariantError"));
    }
  }
}
